import React from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/images/logo.svg";
import NavbarFilter from "./NavbarFilter";
import NavMenu from "./NavMenu";

export default function Navbar() {
  return (
    <>
      <nav className="py-4 2xl:px-6">
        <div className="container flex items-center justify-between">
          <img src={logo} alt="Logo" width="150px" className="object-contain" />
          <NavMenu/>
          <NavbarFilter/>
        </div>
      </nav>
    </>
  );
}
